/**
 * Shared layout values for the landing page, lifted verbatim out of the
 * design's `Landing.jsx` so every section stays on the same grid.
 *
 * Mobile is the primary layout (390px); desktop kicks in above 720px. The
 * per-breakpoint numbers live in `landing.css` as `--l-*` custom properties,
 * so these helpers are the same on the server and in every viewport.
 */

/**
 * Centred page container: 1120px max on desktop, 390px on mobile.
 *
 * The side padding is set as two longhands rather than the `padding`
 * shorthand: every caller spreads this and then adds its own `paddingTop`,
 * and React warns on each rerender when a shorthand and a longhand for the
 * same property meet in one style object.
 */
export function wrap() {
  return {
    maxWidth: 'var(--l-wrap-max)',
    margin: '0 auto',
    paddingLeft: 'var(--l-pad-x)',
    paddingRight: 'var(--l-pad-x)',
    boxSizing: 'border-box',
  }
}

/** Vertical rhythm between sections: 96px desktop, 56px mobile. */
export const SECTION_GAP = 'var(--l-gap)'

/** Section heading scale. */
export function h2Style() {
  return { fontSize: 'var(--l-h2)', margin: 0, letterSpacing: '-0.02em' }
}
